var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"180px"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"上传证件"}},[_c('ImgUpload',{attrs:{"required":false,"upload-config":{
              lebal: '身份证人像面照片',
              prefix: 'identification',
              form: _vm.form,
              suffix: 'Img'
            },"parent-data":_vm.parentData}}),_c('ImgUpload',{attrs:{"required":false,"upload-config":{
              lebal: '身份证国徽面照片',
              prefix: 'identificationBack',
              form: _vm.form,
              suffix: 'Img'
            },"parent-data":_vm.parentData}}),_c('ImgUpload',{attrs:{"required":false,"upload-config":{
              lebal: '实际承运人半身照',
              prefix: 'driver',
              form: _vm.form,
              suffix: 'Img'
            },"parent-data":_vm.parentData}})],1)],1)],1),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"备注"}},[_c('el-input',{attrs:{"type":"textarea","disabled":""},model:{value:(_vm.form.verifyRemark),callback:function ($$v) {_vm.$set(_vm.form, "verifyRemark", $$v)},expression:"form.verifyRemark"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }